export const COUNTER_LOG_REQUEST = '@@counter/LOG_REQUEST';
export enum CounterEvenType {
    ITEM_REQUEST = 'item_request',
    ITEM_INVESTIGATION = 'item_investigation',
    SEARCH_PLATFORM = 'search_platform',
    SEARCH_AUTOMATED = 'search_automated',
    SEARCH_REGULAR = 'search_regular',
}
